"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = serverTimeDelta;
var _types = require("../../actions/serverTime/types");
function serverTimeDelta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_SERVER_TIME_DELTA) return action.payload;
  return state;
}